import { Formik } from 'formik';

import { useLoggedInTransferFormData } from 'src/app/hooks/feature_data/useLoggedInTransferFormData';

import type { RenderedStepComponentProps } from '..';
import type { PharmacyFormValues } from '../../../PharmacySearch';
import { PharmacyFormRenderer } from '../../../PharmacySearch';
import Step from '../Step';

import { validation } from './validation';

interface LoggedInTransferPharmacySearchProps extends RenderedStepComponentProps {
  zipCode: string;
}

export const LoggedInTransferPharmacySearch = (props: LoggedInTransferPharmacySearchProps) => {
  const { loggedInTransferFormData, setLoggedInTransferFormData } = useLoggedInTransferFormData();

  const { handleNextClick, zipCode, setShowCopyrightFooter } = props;

  const setTransferFormValues = (values: PharmacyFormValues) => {
    // Pharmacy search component uses pharmacyStreets as the address
    const { pharmacyStreets, ...rest } = values;
    setLoggedInTransferFormData({
      ...loggedInTransferFormData,
      ...rest,
      pharmacyAddress: pharmacyStreets,
    });
  };

  const title = loggedInTransferFormData?.patientIsPrimary
    ? 'Which pharmacy has your prescriptions?'
    : `Which pharmacy has ${loggedInTransferFormData?.patientName}’s prescriptions?`;

  return (
    // Regular whitespace caused the sub-title to not render at all, which broke the layout. So U+200E it is.
    <Step title={title} text="‎ ">
      <Formik
        initialValues={{
          ...validation.initialValues,
          ...(loggedInTransferFormData && {
            pharmacyName: loggedInTransferFormData.pharmacyName,
            pharmacyPhone: loggedInTransferFormData.pharmacyPhone,
            pharmacyStreets: loggedInTransferFormData.pharmacyAddress,
            pharmacyZipCode: loggedInTransferFormData.pharmacyZipCode,
            pharmacyZipCodeLatitude: loggedInTransferFormData.pharmacyZipCodeLatitude,
            pharmacyZipCodeLongitude: loggedInTransferFormData.pharmacyZipCodeLongitude,
          }),
        }}
        validationSchema={validation.schema}
        onSubmit={async values => {
          await setTransferFormValues(values);
          handleNextClick();
        }}
      >
        <PharmacyFormRenderer
          initialZipCode={zipCode ?? ''}
          setShowFooter={setShowCopyrightFooter}
          transferForm={loggedInTransferFormData}
          hasParentForm={false}
        />
      </Formik>
    </Step>
  );
};
